export function convertObjectToBlob(obj: unknown): Blob {
  const str = JSON.stringify(obj, null, 2);
  const bytes = new TextEncoder().encode(str);
  return new Blob([bytes], {
    type: 'application/json;charset=utf-8'
  });
}
